import React, { useState } from 'react'

// @material-ui/core components
import { Breadcrumbs } from '@mui/material';
import { makeStyles } from "tss-react/mui";

// core components
import Footer from '../../../components/Footer/Footer.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import Header from '../../../components/Header/Header.js'
import HeaderLinks from "../../../components/Header/HeaderLinks.js";
import PreFooter from "../../../pages-sections/LandingPage-Sections/PreFooter.js";
import Link from "next/link.js";
import Parallax from '../../../components/Parallax/Parallax.js';

import styles from "../../../styles/jss/nextjs-material-kit/pages/forumsStyle.js";

// sections for this page
import ForumsBanner from '../../../components/ForumsBanner/ForumsBanner.js';
import ForumsCategories from '../../../components/ForumsCategories/ForumsCategories.js';
import ForumsNoTopics from '../../../components/ForumsNoTopics/ForumsNoTopics.js';
import ForumsSidePanel from '../../../components/ForumsSidePanel/ForumsSidePanel.js';
import ForumsTopicsSection from '../../../components/ForumsTopicsSection/ForumsTopicsSection.js';
import ForumsTopicCard from '../../../components/ForumsTopicCard/ForumsTopicCard.js';

import logo from "../../../public/img/logo.png";
import headerBg from "../../../public/img/forums/forumsHeaderImg.png";
import ForumsLoader from "../../../components/ForumsLoader/ForumsLoader";
import {useRouter} from "next/router";
import {ForumProvider, useForumContext} from "../../../contexts/forum";
import {TopicListProvider, useTopicListContext} from "../../../contexts/topicList";
import Error from "next/error";
import Script from "next/script";
import {SWRConfig, unstable_serialize} from "swr";
import {client} from "../../../request/client";
import {buildSlug} from "../../../util/url";

const dashboardRoutes = [];
const useStyles = makeStyles()(styles);

function ForumsIdPage(props) {
    const [registerModal, setRegisterModal] = useState(false);
    const { ...rest } = props;
    const { classes, cx } = useStyles();

    const { forums, isLoadingForums  } = useForumContext();
    const { topics, isLoadingTopics, reloadTopics  } = useTopicListContext();

    const mobileBreadcrumbLink = () => {
      let breadcrumbLink = "";
      if (forums?.breadcrumbs == null || forums?.breadcrumbs.length === 0) {
        return null;
      }
      else if (forums?.breadcrumbs.length === 1) {
        breadcrumbLink = `/community`;
      }
      else if (forums?.breadcrumbs.length > 1) {
        breadcrumbLink = `/community/${buildSlug(forums.breadcrumbs[forums.breadcrumbs.length - 1].catName)}-${forums?.breadcrumbs[forums?.breadcrumbs?.length - 2]?.id}`
      }
      return breadcrumbLink;
    };

    return (
        <div>
            <Header
                color="transparent"
                routes={dashboardRoutes}
                logo={logo}
                rightLinks={<HeaderLinks />}
                registerModal={registerModal}
                setRegisterModal={setRegisterModal}
                fixed
                changeColorOnScroll={{
                    height: 400,
                    color: "white",
                }}
                {...rest}
            />
            {!isLoadingForums && (forums?.category == null) &&
              <Error statusCode={404} />
            }
            {isLoadingForums ? (
              <ForumsLoader />
            ) : (
              <>
              {(forums && forums.category !== null) &&
                <>
                {forums?.category?.singleThreaded === true ?
                ( 
                    <Parallax image={headerBg.src} forums={true}>
                        <div className={classes.titleBannerContainer}>
                            <h5 className={classes.title}>Community Guidelines</h5>
                            <p className={classes.subtitle}>Read this to keep this space friendly, helpful, and safe. Follow these simple rules to respect each other, stay on-topic, and protect everyone’s privacy. Let’s make this a supportive community for all!</p>
                        </div>
                    </Parallax>
                ) : (
                    <ForumsBanner data={forums} />
                )}
                <div className={classes.container}>
                    <Breadcrumbs separator="›" aria-label="breadcrumb" className={cx(classes.breadcrumbs + " " + classes.desktopView)}>
                        <Link href="/community">Success at School Community</Link>
                        {forums?.breadcrumbs.map((breadcrumb, index) => {
                          return (
                            <Link href={`/community/${buildSlug(breadcrumb?.catName)}-${breadcrumb?.id}`} key={index}>
                              {breadcrumb?.catName}
                            </Link>
                          );
                        })}
                    </Breadcrumbs>
                    <Link href={mobileBreadcrumbLink()} key={forums?.breadcrumbs[forums?.breadcrumbs?.length - 1]?.id} className={cx(classes.breadcrumbs + " " + classes.mobileView)} >
                        <FontAwesomeIcon icon={faChevronLeft} className={classes.breadcrumbsIcon} />
                        {forums?.breadcrumbs[forums.breadcrumbs.length - 1]?.catName}
                    </Link>
                  {isLoadingTopics ? <>
                      <ForumsLoader />
                    </> :
                    topics?.length === 0 ? (
                        <>
                            {forums.subCategories?.length > 0 ? (
                                <ForumsCategories data={forums} />
                            ) : (
                                <div className={classes.forumWithSidePanel}>
                                    <ForumsNoTopics data={forums} />
                                    <ForumsSidePanel data={forums} postView={false} community={forums?.name} />
                                </div>
                            )}
                        </>
                    ) : (
                        forums?.category?.singleThreaded === true ? (
                          <div className={classes.fullWidth}>
                            <ForumsTopicCard
                              reload={reloadTopics}
                              topic={topics[0]}
                              key={topics[0]?.topicId}
                              postView={true}
                              community={forums?.category?.name}
                              initial={true}
                            />
                          </div> 
                        ) : (
                        <div className={classes.forumWithSidePanel}>
                            <ForumsTopicsSection data={forums} topics={topics} />
                            <ForumsSidePanel data={forums} postView={false} community={forums?.name} />
                        </div>
                        )
                    )}
                </div>
                </>}
                </>
              )}
              <div className={cx(classes.darkBlue, classes.workSection)}>
                  <PreFooter />
              </div>
              <div className={classes.footer}>
                  <Footer />
              </div>
            <Script
              src="/assets/libs/tinymce/tinymce.min.js"
              strategy="afterInteractive"
            />
          </div>
      );
}

export default function ForumsIdProviderPage(props) {
  return (
    <SWRConfig value={{ fallback: props.fallback }}>
      <TopicListProvider forumId={props.communityId}>
        <ForumProvider forumId={props.communityId}>
          <ForumsIdPage {...props} />
        </ForumProvider>
      </TopicListProvider>
    </SWRConfig>
  );
}

export async function getServerSideProps({ query }) {
  const communityId = query.communitySlug?.split("-").pop();

  try {
    const data = await client({
      url: `/v1/forums/${communityId}`,
      method: "get",
      headers: {},
    }).then((res) => res.data);

    return {
      props: {
        communityId,
        fallback: {
          [unstable_serialize([`/v1/forums/${communityId}`, {}])]: data,
        },
      }
    };
  }
  catch (e) {
    if (e.response && e.response.status === 404) {
      return {
        notFound: true,
      };
    }
    else {
      throw e;
    }
  }
}
